<template>
  <!--
  temporary comment out because first object is partially hidden under search filter box
  <div class="search-list-filter-full-wrap">
  -->
  <div
    class="search-list-filter-full d-none d-md-block"
  >
    <component-observer
      :placeholder-style="{ display: 'none' }"
      @component-intersected="componentIntersected = true"
    />
    <div class="padding">
      <div class="row row-tight">
        <div class="col-lg-4">
          <div class="form-group">
            <label
              class="d-block"
              for="filter_suggestion"
            >
              <suggestion
                id="filter_suggestion"
                :button-show="true"
              />
            </label>
          </div>
        </div>
        <div class="col-6 col-lg-4">
          <div class="form-group">
            <label
              class="d-block"
              for="flatPickerTraveldate"
            >
              <flat-pickr-base
                id="flatPickerTraveldate"
                v-model="fpModelValue"
                :can-init="componentIntersected"
                :extended-input-emit="true"
                :show-clear-button="true"
                :month-count="2"
                :max-duration="28"
                :open-directly="openDatePicker"
                @on-ready="fpInputValue = $event"
              />
            </label>
          </div>
        </div>
        <div class="col-6 col-lg-4">
          <div class="form-group">
            <select-persons
              v-model="persons"
              :value="persons"
              :persons-max="28"
            />
          </div>
        </div>
      </div>
      <div class="btns clearfix row">
        <div class="d-none d-md-block justify-content-md-start col-sm-10 col-md-10 col-lg-12">
          <div
            class="btn-group btn-search-filter"
            :class="{active:activeAccomodation > 0}"
          >
            <b-button
              id="popover-filter-unterkunft"
            >
              {{ $t("filter:select.tabs:accomodation_interval",{ postProcess: 'interval', count: activeAccomodation }) }}
            </b-button>
            <button
              ref="accomodation"
              class="remove"
              :class="{hidden:activeAccomodation === 0}"
              type="button"
              :data-ident="`resetAccomodation`"
              @click="filterReset('accomodation')"
            >
              <i class="icon">
                <icon-times-alternative />
              </i>
            </button>
          </div>
          <b-popover
            v-if="componentIntersected"
            placement="bottomleft"
            target="popover-filter-unterkunft"
            variant="filter-unterkunft"
            delay="0"
            triggers="click blur"
            @hidden="onHidden"
            @show="onShow"
          >
            <div class="row">
              <div class="col-6">
                <div class="placeholder-label active">
                  <div class="form-group">
                    <label
                      class="hover"
                      for="selectFilterObjectType"
                    >
                      <span>
                        {{ $t('filter:art') }}
                      </span>
                    </label>

                    <b-form-select
                      id="selectFilterObjectType"
                      v-model="objectType"
                      class="form-control"
                      :options="objectTypes"
                      :class="{active:objectType !== ''}"
                    />
                  </div>
                </div>
              </div>
              <div
                class="col-6"
              >
                <div class="placeholder-label active">
                  <div class="form-group">
                    <label
                      class="hover"
                      for="selectFilterSleeping"
                    >
                      <span>
                        {{ $t("filter:select:sleeping") }}
                      </span>
                    </label>
                    <b-form-select
                      id="selectFilterSleeping"
                      v-model="sleepingRooms"
                      class="form-control"
                      :options="sleepingRoomOptions"
                      :class="{active:parseInt(sleepingRooms,10) > 0}"
                    />
                    <!-- <select
                      v-model="sleepingRooms"
                      class="form-control"
                      :class="{active:parseInt(sleepingRooms,10) > 0}"
                    >
                      <option value="">
                        {{ $t("filter:options.long.sleeping_interval", { postProcess: 'interval', count: 0 }) }}
                      </option>
                      <option
                        v-for="sleepingroom in 11"
                        :key="sleepingroom"
                        :value="sleepingroom"
                      >
                        mind. {{ sleepingroom }}
                        {{ ((filterTypeCounter('sleeping', sleepingroom) > 0)
                          ? ' (' +filterTypeCounter('sleeping', sleepingroom) + ')' : '')
                        }}
                      </option>
                    </select> -->
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="placeholder-label active">
                  <div class="form-group">
                    <label
                      class="hover"
                      for="selectFilterBathrooms"
                    >
                      <span>
                        {{ $t('filter:bathrooms') }}
                      </span>
                    </label>
                    <b-form-select
                      id="selectFilterBathrooms"
                      v-model="bathRooms"
                      :options="bathVariantOptions"
                      class="form-control"
                      :class="{active:parseInt(bathRooms,10) > 0}"
                    />
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="placeholder-label active">
                  <div class="form-group">
                    <label
                      class="hover"
                      for="selectFilterLiving"
                    >
                      <span>
                        {{ $t("filter:select:squaremeterLiving") }}
                      </span>
                    </label>
                    <b-form-select
                      id="selectFilterLiving"
                      v-model="squaremeterLiving"
                      :options="squaremeterLivingOptions"
                      class="form-control"
                      :class="{active:parseInt(squaremeterLiving,10) > 0}"
                    />
                  </div>
                </div>
              </div>
            </div>
          </b-popover>

          <div
            class="btn-group btn-search-filter"
            :class="{active:petVariantOptions.indexOf(petVariantOptions.find(item => item.value === pets)) > 0}"
          >
            <b-button
              id="popover-filter-haustiere"
            >
              {{
                $t("filter:select.tabs:pet_interval",{
                  postProcess: 'interval',
                  count: Math.max(petVariantOptions.indexOf(petVariantOptions.find(item => item.value === pets)),0) })
              }}
            </b-button>
            <button
              class="remove"
              :class="{hidden:petVariantOptions.indexOf(petVariantOptions.find(item => item.value === pets)) <= 0}"
              type="button"
              :data-ident="`resetPets`"
              @click="filterReset('pets')"
            >
              <i class="icon">
                <icon-times-alternative />
              </i>
            </button>
          </div>
          <b-popover
            placement="bottomleft"
            target="popover-filter-haustiere"
            variant="filter-haustiere"
            delay="0"
            triggers="click blur"
            @hidden="onHidden"
            @show="onShow"
          >
            <div class="placeholder-label active">
              <div class="form-group">
                <label
                  class="hover"
                  for="selectFilterPet"
                >
                  <span>
                    {{ $t("filter:select:pet") }}
                  </span>
                </label>
                <b-form-select
                  id="selectFilterPet"
                  v-model="pets"
                  class="form-control"
                  :options="petVariantOptions"
                  :class="{active:petVariantOptions.indexOf(petVariantOptions.find(item => item.value === pets)) > 0}"
                />
              </div>
            </div>
          </b-popover>
          <div
            class="btn-group btn-search-filter"
            :class="{active:activePrice}"
          >
            <b-button
              id="popover-filter-preis"
            >
              <span v-show="activePrice">
                {{ priceString }}
              </span>
              <span v-if="!activePrice">
                {{ $t('filter:btns:price') }}
              </span>
            </b-button>
            <button
              class="remove"
              :class="{hidden:!activePrice}"
              type="button"
              :data-ident="`resetPrice`"
              @click="filterReset('price')"
            >
              <i class="icon">
                <icon-times-alternative />
              </i>
            </button>
          </div>
          <b-popover
            placement="bottomleft"
            target="popover-filter-preis"
            variant="filter-preis"
            delay="0"
            triggers="click blur"

            @hidden="onHidden"
            @show="onShow"
          >
            <filter-price-range />
          </b-popover>
          <div
            class="btn-group btn-search-filter"
            :class="{active:parseInt(rating,10) > 0}"
          >
            <b-button
              id="popover-filter-bewertung"
            >
              {{ $t("filter:select.tabs.rating_interval",{ postProcess: 'interval', count: parseInt(rating,10) }) }}
            </b-button>
            <button
              class="remove"
              :class="{hidden:parseInt(rating,10) === 0}"
              type="button"
              :data-ident="`resetRating`"
              @click="filterReset('rating')"
            >
              <i class="icon">
                <icon-times-alternative />
              </i>
            </button>
          </div>
          <b-popover
            placement="bottomleft"
            target="popover-filter-bewertung"
            variant="filter-bewertung"
            delay="0"
            triggers="click blur"
            @hidden="onHidden"
            @show="onShow"
          >
            <div class="placeholder-label active">
              <div class="form-group">
                <label
                  class="hover"
                  for="filterRating"
                >
                  <span>
                    {{ $t("filter:select.tabs.rating_simple") }}
                  </span>
                </label>
                <b-form-select
                  id="filterRating"
                  v-model="rating"
                  class="form-control"
                  :class="{active:parseInt(rating,10) > 0}"
                  :options="ratingOptions"
                />
              </div>
            </div>
          </b-popover>

          <div
            class="btn-group btn-search-filter"
            :class="{active:activeDistances > 0}"
          >
            <b-button
              id="popover-filter-entfernung"
            >
              {{ $t("filter:select.tabs.distance_interval",{ postProcess: 'interval', count: activeDistances }) }}
            </b-button>
            <button
              class="remove"
              :class="{hidden:activeDistances === 0}"
              type="button"
              :data-ident="`resetDistances`"
              @click="filterReset('distances')"
            >
              <i class="icon">
                <icon-times-alternative />
              </i>
            </button>
          </div>
          <b-popover
            placement="bottomleft"
            target="popover-filter-entfernung"
            variant="filter-entfernung"
            delay="0"
            triggers="click blur"
            @hidden="onHidden"
            @show="onShow"
          >
            <div class="row">
              <div class="col-6">
                <filter-distance
                  name="distSea"
                  :show-seperator="true"
                />
              </div>
              <div class="col-6">
                <filter-distance
                  name="distLake"
                  :show-seperator="true"
                />
              </div>
              <div class="col-6">
                <filter-distance
                  name="distSkilift"
                  :show-seperator="true"
                />
              </div>
              <div class="col-6">
                <filter-distance
                  name="distSkiloipe"
                  :show-seperator="true"
                />
              </div>
            </div>
          </b-popover>
          <div
            class="btn-group btn-search-filter"
            :class="{active:activeAmenitiesCount > 0}"
          >
            <b-button
              id="popover-filter-ausstattung"
            >
              {{ $t("filter:select.tabs:amenities_interval",{postProcess: 'interval', count: activeAmenitiesCount }) }}
            </b-button>
            <button
              class="remove"
              :class="{hidden:activeAmenitiesCount === 0}"
              type="button"
              :data-ident="`resetAmenities`"
              @click="filterReset('amenities')"
            >
              <i class="icon">
                <icon-times-alternative />
              </i>
            </button>
          </div>
          <b-popover
            placement="bottomleft"
            target="popover-filter-ausstattung"
            variant="filter-ausstattung"
            delay="0"
            triggers="click blur"
            custom-class="pl-3"
            @hidden="onHidden"
            @show="onShow"
          >
            <div class="row">
              <filter-bool
                v-for="item in searchFilter"
                :key="item"
                :name="item"
                class="col-6"
                :show-seperator="true"
              />
            </div>
          </b-popover>

          <div
            v-if="startDate && !deactivateTolerance"
            class="btn-group btn-search-filter "

            :class="{active:tolerance !== ''}"
          >
            <b-button
              id="popover-filter-tolerance"
              data-name="tolerance"
            >
              {{
                $t("filter:select.tabs:dateTolerance_variant",{postProcess: 'interval', count: tolerance })
              }}
            </b-button>
            <button
              class="remove"
              data-name="tolerance-reset"
              type="button"
              :class="{hidden:tolerance === ''}"
              :data-ident="`resetTolerance`"
              @click="resetTolerance()"
            >
              <i class="icon">
                <icon-times-alternative />
              </i>
            </button>
          </div>
          <b-popover
            v-if="startDate"
            placement="bottomleft"
            target="popover-filter-tolerance"
            variant="filter-tolerance"
            delay="0"
            triggers="click blur"
            @hidden="onHidden"
            @show="onShow"
          >
            <div class="placeholder-label active">
              <div class="form-group">
                <label
                  class="hover"
                  for="selectFilterTolerance"
                >
                  <span>
                    {{ $t("filter:select:dateTolerance") }}
                  </span>
                </label>
                <b-form-select
                  id="selectFilterTolerance"
                  v-model="tolerance"
                  class="form-control"
                  :options="toleranceVariantOptions"
                />
              </div>
            </div>
          </b-popover>
          <div
            v-if="UserApi_checkPermission('search.filterAgency.show')"
            class="btn-group btn-search-filter"
            :class="{active:activeAgenciesCount > 0}"
          >
            <b-button
              id="popover-filter-agentur"
            >
              {{ $t("filter:select.tabs:agency_interval",{postProcess: 'interval', count: activeAgenciesCount }) }}
            </b-button>
            <button
              class="remove"
              type="button"
              :class="{hidden:activeAgenciesCount === 0}"
              :data-ident="`resetAgencies`"
              @click="filterReset('agencies')"
            >
              <i class="icon">
                <icon-times-alternative />
              </i>
            </button>
          </div>
          <b-popover
            v-if="UserApi_checkPermission('search.filterAgency.show')"
            placement="bottomleft"
            target="popover-filter-agentur"
            variant="filter-agentur"
            delay="0"
            triggers="click blur"
            @hidden="onHidden"
            @show="onShow"
          >
            <div
              v-if="UserApi_checkPermission('search.filterAgency.internal')"
              class="row"
            >
              <div
                v-for="option in providerTypes"
                :key="option.value"
                class="col-4"
              >
                <b-form-radio
                  :id="'provider_' + option.value"
                  v-model="providerType"
                  :value="option.value"
                  :name="'provider_' + option.value"
                >
                  {{ $t(`filter:providerTypes.${option.text}`) }}
                </b-form-radio>
              </div>
            </div>
            <div
              v-if="UserApi_checkPermission('search.filterAgency.internal')"
              class="row"
            >
              <div
                v-for="option in insObjectTypes"
                :key="option.value"
                class="col-4"
              >
                <b-form-radio
                  :id="'insObject_' + option.value"
                  v-model="insObject"
                  :value="option.value"
                  :name="'insObject_' + option.value"
                >
                  {{ $t(`filter:insObject.${option.text}`) }}
                </b-form-radio>
              </div>
            </div>
            <BFormCheckboxGroup v-model="agencySelect">
              <div
                class="row"
              >
                <div
                  v-for="(actAgency) in agencies"
                  :key="actAgency"
                  class="col-6"
                >
                  <b-form-checkbox :value="actAgency">
                    {{ $t("agency:agencyNames." + actAgency) }} {{ filterTypeCount('agencies', actAgency) }}
                  </b-form-checkbox>
                </div>
              </div>
            </BFormCheckboxGroup>
          </b-popover>
          <div
            v-if="UserApi_checkPermission('search.useLabels')"
            class="btn-group btn-search-filter"
            :class="{active:activeLabelCount > 0}"
          >
            <b-button
              id="popover-filter-label"
            >
              {{ $t("filter:select.tabs:label_interval",{postProcess: 'interval', count: activeLabelCount }) }}
            </b-button>
            <button
              class="remove"
              :class="{hidden:activeLabelCount === 0}"
              type="button"
              :data-ident="`resetPrice`"
              @click="filterReset('label')"
            >
              <i class="icon">
                <icon-times-alternative />
              </i>
            </button>
          </div>
          <b-popover
            v-if="UserApi_checkPermission('search.useLabels')"
            placement="bottomleft"
            target="popover-filter-label"
            variant="filter-label"
            delay="0"
            triggers="click blur"
            @hidden="onHidden"
            @show="onShow"
          >
            <b-form-checkbox-group
              v-model="partnerTagsSelect"
              stacked
            >
              <b-form-checkbox
                v-for="(partnerTagValue, partnerTagKey) in partnerTags"
                :key="'partnerTag_' + partnerTagKey"
                :value="partnerTagKey"
              >
                {{ $t("partnerTags:" + partnerTagName + '.badges.' + partnerTagKey) }} ({{ formatNumber(partnerTagValue) }})
              </b-form-checkbox>
            </b-form-checkbox-group>
          </b-popover>
          <div
            v-if="showCancelations"
            class="btn-group btn-search-filter"
            :class="{active:freeCancel === 'Y'}"
          >
            <b-button @click="useFreeCancel()">
              {{ $t("filter:freeCancel") }}
            </b-button>
            <button
              class="remove"
              :class="{hidden:freeCancel !== 'Y'}"
              type="button"
              @click="filterReset('freeCancel')"
            >
              <i class="icon">
                <icon-times-alternative />
              </i>
            </button>
          </div>
          <div
            v-if="offer"
            class="btn-group btn-search-filter active"
          >
            <button
              id="popover-filter-test"
              class="btn btn-secondary"
              type="button"
            >
              {{ $t('filter:offer') }} {{ offerName }}
            </button>
            <button
              class="remove"
              type="button"
              @click="removeOffer"
            >
              <i class="icon">
                <icon-times-alternative />
              </i>
            </button>
          </div>
          <div
            v-if="lastminute"
            class="btn-group btn-search-filter active"
          >
            <button
              id="popover-filter-test"
              class="btn btn-secondary"
              type="button"
            >
              {{ $t('filter:lastMinute') }}
            </button>
            <button
              class="remove"
              type="button"
              @click="removeLastminute"
            >
              <i class="icon">
                <icon-times-alternative />
              </i>
            </button>
          </div>

          <div
            v-show="group === 'Y'"
            class="btn-group btn-search-filter active"
          >
            <button
              id="popover-filter-test"
              class="btn btn-secondary"
              type="button"
            >
              {{ $t('filter:variant') }}
            </button>
            <button
              class="remove"
              type="button"
              @click="removeGroup"
            >
              <i class="icon">
                <icon-times-alternative />
              </i>
            </button>
          </div>
        </div>
        <div class="col-sm-3 col-md-2 d-lg-none">
          <button
            class="btn btn-secondary float-right "
            type="button"
            @click="toggleMap"
          >
            <i class="icon"><icon-map-marker-alt /></i>
            {{ $t('filter:btns.map') }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
import 'scss/bootstrap/vue/components/popover.scss';

import FlatpickrSearchFunctions from 'mixins/FlatpickrSearchFunctions';
import getNumberFormat from 'mixins/composition/NumberFormat';
import FilterDistance from 'components/FilterDistance.vue';
import ComponentObserver from 'components/loading/ComponentObserver.vue';

import DeviceHelper from 'mixins/DeviceHelper';
import hydrationPreventionSetup from 'mixins/composition/search/HeaderSearchHydrationPrevention';
import config from 'config/appConfig';

/* ICONS */
import IconTimesAlternative from 'ICON:IconTimesAlternative';
import IconMapMarkerAlt from 'ICON:IconMapMarkerAlt';
import searchRedirect from 'mixins/composition/search/SearchFunctions';

// eslint-disable-next-line import/no-extraneous-dependencies
import UserApi from 'mixins/UserApi';

import { mapGetters, mapMutations } from 'vuex';
import { onMounted } from '@vue/composition-api';
import { BFormSelect, BPopover, BButton } from 'bootstrap-vue';
import {
  computed, data, components, methods, watch,
} from '@/mixins/SearchFilter';



export default {
  name: 'SearchFilterMenu',
  i18nOptions: { namespaces: ['filter', 'agency'] },
  components: {
    FilterDistance,
    BFormSelect,
    BPopover,
    BButton,
    IconTimesAlternative,
    IconMapMarkerAlt,
    ComponentObserver,
  },
  // computed, data, components located in /mixins/SearchFilter
  mixins: [FlatpickrSearchFunctions,
    computed, data, components, methods, watch, DeviceHelper, UserApi],
  setup(_, ctx) {
    const { dispatchMountSignal } = hydrationPreventionSetup(ctx.root.$store, ctx.root, ctx.refs);
    onMounted(() => { dispatchMountSignal('searchFilterMenu'); });
    const { formatNumber, formatCurrency } = getNumberFormat(ctx);
    return { formatNumber, formatCurrency, searchRedirect };
  },
  data() {
    return {
      componentIntersected: false,
      breakpointPrefix: 'long',
      menuOpened: false,
      selectedPrice: 'n/a',
      greyInProgress: false,
      activePrice: false,
    };
  },
  computed: {
    priceString() {
      this.setInActivePrice();
      const priceMin = this.$store.getters.getSearchFilter('priceMin');
      let priceMax = this.$store.getters.getSearchFilter('priceMax');
      if (priceMax === config.defaults.searchPriceMax) {
        priceMax = 0;
      }
      if (priceMax > 0 && priceMin > 0) {
        this.setActive('price');
        return `${this.formatCurrency(priceMin, undefined, undefined, { minimumFractionDigits: 0 })} - ${this.formatCurrency(priceMax, undefined, undefined, { minimumFractionDigits: 0 })}`;
      }
      if (priceMin > 0) {
        this.setActive('price');
        return this.$t('filter:select.tabs:price_interval', {
          postProcess: 'interval',
          count: 2, // only for post process decision
          price: this.formatCurrency(priceMin, undefined, undefined, { minimumFractionDigits: 0 }), // for string output
        });
      }
      if (priceMax > 0) {
        this.setActive('price');
        return this.$t('filter:select.tabs:price_interval', {
          postProcess: 'interval',
          count: 1, // only for post process decision
          price: this.formatCurrency(priceMax, undefined, undefined, { minimumFractionDigits: 0 }), // for string output
        });
      }

      return this.$t('filter:select.tabs:price_interval', {
        postProcess: 'interval',
        count: 0, // only for post process decision
      });
    },
    activeFilter() {
      return this.getActiveFilterCount();
    },
  },
  mounted() {
    this.setPrefix();
  },
  methods: {
    ...mapGetters({ getActiveFilterCount: 'getActiveFilterCount', getMapStatus: 'getMapStatus' }),
    ...mapMutations({ setModalStatus: 'SET_MODAL_STATUS', setMapStatus: 'SET_MAP_STATUS' }),
    toggleMap() {
      this.$emit('open-map', true);
      this.setMapStatus({ fullscreen: !this.getMapStatus() });
    },
    setActive(type) {
      switch (type) {
        case 'price':
          this.activePrice = true;
          break;
        default:
          return false;
      }
      return true;
    },
    setInActivePrice() {
      this.activePrice = false;
    },
    setPage() {
      searchRedirect({ router: this.$router, filters: { page: this.page } });
    },
    resetTolerance() {
      this.setSearchFilter({
        tolerance: '',
      });
      this.$router.push({
        name: 'Search',
        hash: '#searchResult',
        query: this.$store.getters.getMergedTerms,
      });
    },
    toggleFiltermenu(menuShow) {
      // close filtermenu
      if (this[menuShow] === true) {
        this[menuShow] = false;
        this.menuOpened = false;
      } else {
        this.menuOpened = true;
        // open filtermenu. only one at a time
        this.filterUnterkunft = (menuShow === 'filterUnterkunft');
        this.filterHaustiere = (menuShow === 'filterHaustiere');
        this.filterPreis = (menuShow === 'filterPreis');
        this.filterKundenbewertung = (menuShow === 'filterKundenbewertung');
        this.filterEntfernungen = (menuShow === 'filterEntfernungen');
        this.filterAusstattung = (menuShow === 'filterAusstattung');
      }
    },
    onHidden() {
      // Called just after the popover has finished hiding
      this.$nextTick(() => {
        if (!this.greyInProgress) { this.$store.commit('SET_SEARCH_OVERGREY', { status: false }); }
      });
    },
    onShow() {
      // This is called just before the search filter popover is shown
      // eslint-disable-next-line vue/custom-event-name-casing
      this.$root.$emit('bv::hide::popover');
      this.greyInProgress = true;
      this.$store.commit('SET_SEARCH_OVERGREY', { status: true });
      setTimeout(() => {
        this.greyInProgress = false;
      }, 500);
    },
    filterReset(resetObject) {
      const emptyObject = {};
      const toReset = this.filterGroups[resetObject];
      toReset.forEach((property) => {
        emptyObject[property] = null;
      });
      const resetLocale = `filter:reset.${resetObject}`;
      this.dataLayerPush({ event: 'asnnutzung', asnfilter: this.$t(resetLocale) });
      searchRedirect({ router: this.$router, filters: { ...this.$router.currentRoute.query, ...emptyObject } });
    },
  },
};
</script>

<style lang="scss" src="@/scss/components/search/SearchFilterMenu.scss" scoped clientextend></style>
